module.exports = __webpack_public_path__ + "static/oinoloth-e67587d3ab9904da04e68c26548aad50.png";